<form [formGroup]="formGroup" fxLayoutAlign="center center">
  <div fxLayout="row" fxLayoutGap="25px" fxFlex="100" class="wrapper">
 
    <div fxLayout="column" fxFlex="50">
      <mat-card fxLayout="column">
        <mat-card-title id="id_campaign_form_header">
         {{ 'LABEL_CAMPAIGN_DETAILS' | translate }}
        </mat-card-title>

        <input #inputFile type="file" (change)="cmpMntService.chooseFile($event, formGroup);inputFile.value = ''" hidden="true">

        <!-- code -->
        <div fxLayout>
          <mat-form-field>
            <input
              id="id_campaign_code_txtbox"
              #code
              matInput
              required
              autocomplete="off" 
              formControlName="code" 
              [placeholder]="'LABEL_CODE' | translate"
              >
          </mat-form-field>
        </div>

        <!-- description -->
        <div fxLayout>
          <mat-form-field>
            <input 
              id="id_campaign_name_txtbox"
              matInput
              required
              #description 
              autocomplete="off" 
              formControlName="description" 
              [placeholder]="'LABEL_DESCRIPTION' | translate"
              >
  
            <mat-error *ngIf="formGroup.controls['description'].hasError('required')">
              {{ 'MSG_FIELD_REQUIRED' | translate }}
            </mat-error>   

            <mat-error *ngIf="formGroup.controls['description'].hasError('maxlength')">
              {{ 'MSG_MAXLENGTH' | translate: {length: '250'} }}
            </mat-error>

            <mat-error *ngIf="formGroup.controls['description'].hasError('pattern')">
              {{ 'MSG_NO_SPECIAL_CHARS' | translate }}
            </mat-error> 

            <mat-error *ngIf="formGroup.controls['description'].hasError('exists')">
              {{ 'MSG_CAMPAIGN_NAME_EXISTS' | translate }}
            </mat-error> 
          </mat-form-field>
        </div>

        <!-- reference_filename -->
        <div fxLayout>
          <mat-form-field>
            <input 
              id="id_ref_name_upload"
              matInput
              required
              readonly
              autocomplete="off" 
              #reference_filename 
              class="cursor-pointer"
              (click)="inputFile.click()" 
              formControlName="reference_filename" 
              [matTooltip]="formGroup.get('reference_filename').value"
              [placeholder]="'LABEL_REFERENCE_FILENAME' | translate"
              >

              <mat-icon 
                id="id_ref_name_upload_btn"
                matSuffix
                svgIcon="attachment" 
                class="cursor-pointer"
                (click)="inputFile.click()" 
                [matTooltip]="'MSG_CHOOSE_FILE' | translate"
                *ngIf="formGroup.enabled"
                >
              </mat-icon>

            <mat-error *ngIf="formGroup.controls['reference_filename'].hasError('required')">
              {{ 'MSG_FIELD_REQUIRED' | translate }}
            </mat-error> 
          </mat-form-field>
        </div>

        <!-- start_date -->
        <div fxLayout>
          <mat-form-field>
            <input 
              id="id_start_date_picker"
              matInput 
              required 
              readonly
              [min]="minDate" 
              [max]="formGroup.get('end_date').value || null"
              (click)="start_date.open()" 
              [matDatepicker]="start_date" 
              formControlName="start_date" 
              [placeholder]="'LABEL_START_DATE' | translate" 
              >

            <mat-datepicker-toggle id="id_start_date_picker_btn" matSuffix [for]="start_date"></mat-datepicker-toggle>
            <mat-datepicker #start_date></mat-datepicker>
            
            <!-- <mat-error *ngIf="formGroup.get('start_date').value < minDate">
              {{ 'MSG_MIN_DATE' | translate: {date: minDate | date: 'mediumDate'} }}
            </mat-error>    -->
            
            <mat-error *ngIf="formGroup.controls['start_date'].hasError('required')">
              {{ 'MSG_FIELD_REQUIRED' | translate }}
            </mat-error>   
          </mat-form-field>
        </div>

        <!-- end_date -->
        <div fxLayout>
          <mat-form-field>
            <input 
              id="id_end_date_picker"
              matInput 
              required 
              readonly
              (click)="end_date.open()" 
              [matDatepicker]="end_date" 
              formControlName="end_date" 
              [min]="formGroup.get('start_date')?.value || minDate" 
              [placeholder]="'LABEL_END_DATE' | translate" 
              >

            <mat-datepicker-toggle id="id_end_date_picker_btn" matSuffix [for]="end_date"></mat-datepicker-toggle>
            <mat-datepicker #end_date></mat-datepicker>  

            <mat-error *ngIf="formGroup.controls['end_date'].hasError('required')">
              {{ 'MSG_FIELD_REQUIRED' | translate }}
            </mat-error> 
          </mat-form-field>
        </div>

        <!-- reversal_number_of_days -->
        <div fxLayout>
          <mat-form-field>
            <input 
              id="id_campaign_reversal_txtbox"
              matInput 
              required 
              formControlName="reversal_number_of_days" 
              [placeholder]="'LABEL_REVERSAL_DAYS' | translate" 
              >

            <mat-error *ngIf="formGroup.controls['reversal_number_of_days'].hasError('required')">
              {{ 'MSG_FIELD_REQUIRED' | translate }}
            </mat-error> 
            
            <mat-error *ngIf="formGroup.controls['reversal_number_of_days'].hasError('pattern')">
              {{ 'MSG_NUMBERS_ONLY' | translate }}
            </mat-error>   
                         
            <mat-error *ngIf="formGroup.controls['reversal_number_of_days'].hasError('min')">
              {{ 'MSG_MIN' | translate: {quantity: 1} }}
            </mat-error>
            
            <mat-error *ngIf="formGroup.controls['reversal_number_of_days'].hasError('maxlength')">
              {{ 'MSG_MAXLENGTH' | translate: {length: '3'} }}
            </mat-error>
          </mat-form-field>
        </div>
      </mat-card>
    </div>

    <div fxLayout="column" fxFlex="50">
      <mat-card fxLayout="column">
        <mat-card-title id="id_campaign_form_header">
         {{ 'LABEL_CAMPAIGN_SMS_RESPONSES' | translate }}
        </mat-card-title>

        <!-- registration_success -->
        <div fxLayout>
          <mat-form-field>
            <input 
              matInput 
              required 
              formControlName="registration_success" 
              [placeholder]="'LABEL_SMS_REGISTRATION_SUCCESS' | translate" 
              >

            <mat-hint align="end">
              {{ formGroup.get('registration_success').value?.length || 0 }} / {{ computeSmsFee(formGroup.get('registration_success').value?.length) }}
            </mat-hint>

            <mat-error *ngIf="formGroup.get('registration_success').hasError('required')">
              {{ 'MSG_FIELD_REQUIRED' | translate }}
            </mat-error> 
          </mat-form-field>
        </div>

        <!-- user_already_registered -->
        <div fxLayout>
          <mat-form-field>
            <input 
              matInput 
              required 
              formControlName="user_already_registered" 
              [placeholder]="'LABEL_SMS_USER_ALREADY_REGISTERED' | translate" 
              >

            <mat-hint align="end">
              {{ formGroup.get('user_already_registered').value?.length || 0 }} / {{ computeSmsFee(formGroup.get('user_already_registered').value?.length) }}
            </mat-hint>

            <mat-error *ngIf="formGroup.get('user_already_registered').hasError('required')">
              {{ 'MSG_FIELD_REQUIRED' | translate }}
            </mat-error> 
          </mat-form-field>
        </div>

        <!-- another_user_registered -->
        <div fxLayout>
          <mat-form-field>
            <input 
              matInput 
              required 
              formControlName="another_user_registered" 
              [placeholder]="'LABEL_SMS_ANOTHER_USER_REGISTERED' | translate" 
              >

            <mat-hint align="end">
              {{ formGroup.get('another_user_registered').value?.length || 0 }} / {{ computeSmsFee(formGroup.get('another_user_registered').value?.length) }}
            </mat-hint>

            <mat-error *ngIf="formGroup.get('another_user_registered').hasError('required')">
              {{ 'MSG_FIELD_REQUIRED' | translate }}
            </mat-error> 
          </mat-form-field>
        </div>

        <!-- user_maxed_coupon -->
        <div fxLayout>
          <mat-form-field>
            <input 
              matInput 
              required 
              formControlName="user_maxed_coupon" 
              [placeholder]="'LABEL_SMS_USER_MAXED_COUPON' | translate" 
              >

            <mat-hint align="end">
              <!-- {{ formGroup.get('user_maxed_coupon').value?.length || 0 }} / {{ computeSmsFee(formGroup.get('user_maxed_coupon').value?.length) | currency: 'PHP':'symbol-narrow' }} -->
              {{ formGroup.get('user_maxed_coupon').value?.length || 0 }} / {{ computeSmsFee(formGroup.get('user_maxed_coupon').value?.length) }}
            </mat-hint>

            <mat-error *ngIf="formGroup.get('user_maxed_coupon').hasError('required')">
              {{ 'MSG_FIELD_REQUIRED' | translate }}
            </mat-error> 
          </mat-form-field>
        </div>
      </mat-card>
    </div>
 
  </div>
 
  <div *ngIf="loadingCampaign" fxLayout="column" fxLayoutAlign="center center" class="loading-indicator-wizard">
    <mat-spinner></mat-spinner>
  </div>
</form>